import { EChartsCoreOption } from 'echarts';
import {
  ChartDataResponseResult,
  ChartProps,
  DataRecordValue,
  QueryFormColumn,
  QueryFormData,
  QueryFormMetric,
  SetDataMaskHook,
} from '@superset-ui/core';
import {
  DEFAULT_LEGEND_FORM_DATA,
  EchartsLegendFormData,
} from '../../../types';
import { defaultBackgroundPattern, defaultPiePattern } from './constants';
import { LabelPosition, LabelAlignment } from '../enums';
import { RGBAColor } from '../../types';

export type EchartsTexturePieFormData = QueryFormData &
  EchartsLegendFormData & {
    groupby: QueryFormData[];
    metric: QueryFormMetric;
    showLabels: boolean;
    tooltipFormat: string;
    backgroundImage: string;
    pieImage: string;
    labelColor: RGBAColor;
    labelLineColor: RGBAColor;
    labelPosition: LabelPosition;
    labelAlignment: LabelAlignment;
    borderColor: RGBAColor;
};

export interface EchartsTexturePieChartProps
  extends ChartProps<EchartsTexturePieFormData> {
  formData: EchartsTexturePieFormData;
  queriesData: ChartDataResponseResult[];
}

// @ts-ignore
export const DEFAULT_FORM_DATA: EchartsTexturePieFormData = {
  ...DEFAULT_LEGEND_FORM_DATA,
  groupby: [],
  showLabels: true,
  tooltipFormat: '{a} <br/>{b} : {c} ({d}%)',
  backgroundImage: defaultBackgroundPattern,
  pieImage: defaultPiePattern,
  labelColor: { r: 35, g: 88, b: 148, a: 1 },
  labelLineColor: { r: 35, g: 88, b: 148, a: 1 },
  labelPosition: LabelPosition.Outer,
  labelAlignment: LabelAlignment.None,
  borderColor: { r: 35, g: 88, b: 148, a: 1 }
};

export interface TexturePieChartTransformedProps {
  formData: EchartsTexturePieFormData;
  height: number;
  width: number;
  echartOptions: EChartsCoreOption;
  setDataMask: SetDataMaskHook;
  labelMap: Record<string, DataRecordValue[]>;
  groupby: QueryFormColumn[];
}